function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledPanoramaCardsCarouselTabsComponent } from "./panorama-cards-carousel-tabs-component.scss";
import { useMemo, useRef, useState } from "react";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { trackEvent } from "services/bigbrain-service";
import { CAROUSEL_ARROW_CLICKED, CAROUSEL_TAB_CLICKED } from "constants/bigbrain-event-types";
import AssetComponent from "components/core/asset/asset-component";
import classnames from "classnames";
import CardComponent from "segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/card/card-component";
export const CAROUSEL_SETTINGS = {
    defaultIndex: 0,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    centerMode: false,
    swipe: false,
    draggable: false,
    dots: false
};
const DEFAULT_TRANSITION_SPEED = 500;
const EVENT_COMPONENT_NAME = "panorama_cards_carousel_tabs_component";
const PanoramaCardsCarouselTabsComponent = ({ tabs, tabAdvancedConfig, advancedAssetProps, transitionSpeed, autoplay, autoplaySpeed })=>{
    const slider = useRef(null);
    const [selectedTab, setSelectedTab] = useState(0);
    const slides = useMemo(()=>tabs === null || tabs === void 0 ? void 0 : tabs.map((tab)=>tab.tabContent), [
        tabs
    ]);
    const backgroundAssets = useMemo(()=>tabs === null || tabs === void 0 ? void 0 : tabs.map((tab)=>{
            var _tab_tabContent;
            return (_tab_tabContent = tab.tabContent) === null || _tab_tabContent === void 0 ? void 0 : _tab_tabContent.asset;
        }), [
        tabs
    ]);
    const carouselTransitionSpeed = parseInt(transitionSpeed) || DEFAULT_TRANSITION_SPEED;
    const itemRenderer = (tab)=>/*#__PURE__*/ _jsx(CardComponent, _object_spread({
            onNextClick: onNextClick,
            onPrevClick: onPrevClick
        }, tab, tabAdvancedConfig));
    const onNextClick = ()=>{
        setSelectedTab((currentTab)=>Math.abs((currentTab + 1) % slides.length));
        trackEvent(CAROUSEL_ARROW_CLICKED, {
            info1: EVENT_COMPONENT_NAME,
            info3: "next"
        });
        slider === null || slider === void 0 ? void 0 : slider.current.next();
    };
    const onPrevClick = ()=>{
        setSelectedTab((currentTab)=>(currentTab - 1 + slides.length) % slides.length);
        trackEvent(CAROUSEL_ARROW_CLICKED, {
            info1: EVENT_COMPONENT_NAME,
            info3: "prev"
        });
        slider === null || slider === void 0 ? void 0 : slider.current.prev();
    };
    const onSlideChange = (index)=>{
        const didChangedByClick = index !== selectedTab;
        if (didChangedByClick) {
            setSelectedTab(index);
            trackEvent(CAROUSEL_TAB_CLICKED, {
                info1: index + 1
            });
        }
    };
    const handleBeforeChange = (oldIndex, newIndex)=>{
        setSelectedTab(newIndex);
    };
    return /*#__PURE__*/ _jsxs(StyledPanoramaCardsCarouselTabsComponent, {
        tabTransitionSpeed: carouselTransitionSpeed,
        className: "panorama-cards-carousel-tabs-component",
        children: [
            /*#__PURE__*/ _jsx(Carousel, _object_spread({
                slidesToShow: 1,
                speed: carouselTransitionSpeed,
                itemRenderer: itemRenderer,
                items: slides,
                ref: slider,
                autoplay: autoplay,
                autoplaySpeed: autoplaySpeed,
                beforeChange: handleBeforeChange
            }, CAROUSEL_SETTINGS)),
            /*#__PURE__*/ _jsx("div", {
                className: "background-asset-container",
                children: backgroundAssets.map((asset, index)=>/*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, asset, advancedAssetProps), {
                        className: classnames({
                            selected: index === selectedTab
                        })
                    }), index))
            })
        ]
    });
};
export default PanoramaCardsCarouselTabsComponent;
